// extracted by mini-css-extract-plugin
export default {"root":"Tag_root__oo8hJ","medium":"Tag_medium__UFOjR Tag_root__oo8hJ","small":"Tag_small__rAnoO Tag_root__oo8hJ","light":"Tag_light__D8p8H","pink":"Tag_pink__8VNJv"};